///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_customer_matching = abcsetup.new_customer_matching || {};
abcsetup.new_customer_matching.events = abcsetup.new_customer_matching.events || {};
abcsetup.new_customer_matching.events.matches_datatable = abcsetup.new_customer_matching.events.matches_datatable || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_customer_matching.events.matches_datatable = {
    init: function() {
        let isSearching = false;

        $(document).on('click', 'a.open-matches-modal', function(){
            var importItemId = $(this).data('import-item');
            axios.get('/api/new_customer_matching/import_items/' + importItemId + '/matches').then(function (response) {
                var $modal = $(response.data.view);

                var $var = response.data.scripts;
                $modal.on('shown.bs.modal', function(event){
                    var script = document.createRange().createContextualFragment($var);
                    event.target.appendChild(script);
                }).on('hide.bs.modal', function(event){
                    window.LaravelDataTables["app_data_tables_new_customer_matching_matches_data_table"].destroy();
                    $(this).remove();
                }).modal('show');
            });
        });

        $(document).on('xhr.dt', '#app_data_tables_new_customer_matching_matches_data_table', function (e, settings, json, xhr) {
            var subcategories = json.subcategories ?? [];
            var segments = json.segments ?? [];
            var subcategory_id = json.subcategory_id ?? 0;
            var segment_id = json.segment_id ?? 0;
            var strict = json.strict;
            var active = json.active;
            var $subcategory_select = $('#subcategory_id');
            var $segment_select = $('#segment_id');

            var subcat_list = '<option value="">- Subcategory -</option>';
            Object.keys(subcategories).forEach(function (key) {
                subcat_list += '<option value="' + subcategories[key]['subcategory_id'] + '"'+ ((subcategories[key]['subcategory_id'] == subcategory_id) ? "selected" : "") +'>' + subcategories[key]['subcategory_name'] + '</option>';
            });
            $subcategory_select.html(subcat_list);

            var seg_list = '<option value="">- Segment -</option>';
            Object.keys(segments).forEach(function (key) {
                seg_list += '<option value="' + segments[key]['segment_id'] + '"'+ ((segments[key]['segment_id'] == segment_id) ? "selected" : "") +'>' + segments[key]['segment_name'] + '</option>';
            });
            $segment_select.html(seg_list);

            $('#strict_matches').prop('checked', strict == 1);
            $('#active_toggle').prop('checked', active == 1);

            if((json.recordsTotal == 0) && (strict == 1)){
                $('#strict_matches').prop('checked', false).trigger("change");
            }

            abcsetup.new_customer_matching.events.items.index.toggleFilterTypeBanner();
        });

        $(document).on("change", "#subcategory_id", function(){
            abcsetup.new_customer_matching.events.items.index.updateDatatable($(this).data('import-item-id'));
        });

        $(document).on("change", "#segment_id", function(){
            abcsetup.new_customer_matching.events.items.index.updateDatatable($(this).data('import-item-id'));
        });

        $(document).on("click", "#strict_matches", function(e){
            if (isSearching) {
                e.preventDefault();
                abcsetup.alerts.show("Search in Progress", "Please clear your search filters before toggling for strict matches.");
                return;
            }

            if (abcsetup.userRole.class == 'private_label_team') {
                if ($('#strict_matches').is(':checked')) {
                    $('#gnp_toggle').prop('checked', false);
                } else {
                    $('#gnp_toggle').prop('checked', true);
                }
            }

            abcsetup.new_customer_matching.events.items.index.updateDatatable($(this).data('import-item-id'));
            abcsetup.new_customer_matching.events.items.index.toggleFilterTypeBanner();
        });

        $(document).on("change", "#active_toggle", function(){
            abcsetup.new_customer_matching.events.items.index.updateDatatable($(this).data('import-item-id'));

            abcsetup.new_customer_matching.events.items.index.toggleFilterTypeBanner();
        });

        $(document).on('click', '#yajra-reset-btn, #matches_modal .reset-column-search', function(e) {
            isSearching = false;
            $("#strict_matches").prop("checked", false);
        });

        $(document).on('click', '#yajra-search-btn', function(e) {
            isSearching = true;
            $("#strict_matches").prop("checked", false);
        });

        $(document).on("click", ".remove-bid", function(event){
            abcsetup.blockUI(true);
            var matchId = $(this).data('match-id');
            axios.put('/api/new_customer_matching/matches/' + matchId, {bid:false}).then(function (response) {
                abcsetup.new_customer_matching.events.items.index.reloadTables();

                if (response.data && response.data.completed == true) {
                    abcsetup.alerts.confirm(
                        'Workflow Task Completed', 
                        'You have removed all matches for this item. Your workflow task has been completed. Please click "Ok" to finalize closing this task.', 
                        function(resp) {
                        if (resp) {
                            window.location.href = '/dashboard';
                        }
                    });
                } else {
                    toastr.success("Match removed from event.");
                }
            });
        });

        $(document).on("click", ".set-match", function(event) {
            abcsetup.blockUI(true);
            var importItemId = $(this).data('import-item-id');
            var matchId = $(this).data('match-id');
            var abcItemId = $(this).data('abc-item-id');
            if(!matchId){
                axios.post('/api/new_customer_matching/import_items/' + importItemId + '/matches/' + abcItemId + '/set').then(function (response) {
                    abcsetup.new_customer_matching.events.items.index.setBid(importItemId, response.data.match_id);
                });
            }else{
                abcsetup.new_customer_matching.events.items.index.setBid(importItemId, matchId);
            }
        });
    },
}